export const FLEET_MAP_COLORS = {
	routeTaken: "#808080",
	routeActive: "#075aae",
	routeRemaining: "#12abf4",
	markerSuccess: "#50b881",
	markerFailed: "#e8887e",
	markerInTransit: "#12abf4",
	markerEnroute: "#075aae",
	markerArrived: "#f59e0b",
	markerOutcome: "#bababa",
}

export const takenPolylineCustomization = {
	strokeColor: FLEET_MAP_COLORS.routeTaken,
	strokeOpacity: 0.8,
	strokeWeight: 6,
}

export const activePolylineCustomization = (params: any) => {
	const distance = params.deliveryVehicle.remainingDistanceMeters
	if (distance <= 5000) {
		for (const polylineObject of params.polylines) {
			polylineObject.setOptions({ strokeColor: FLEET_MAP_COLORS.routeActive })
		}
	}
}

export const getStopMarkerColor = (state: string): string | null => {
	if (state === "ARRIVED") return FLEET_MAP_COLORS.markerArrived
	if (state === "ENROUTE") return FLEET_MAP_COLORS.markerEnroute
	return null
}
